export default {
  common: {
    menu_about: '关于大会',
    menu_sponsor: '参会与赞助',
    menu_venue: '大会地点',
    menu_agenda: '会议日程',
    menu_system: '院校资料录入专区',
    menu_view: '历届回顾',
    city_macao: '澳门',
    city_zhuhai: '珠海',
  },
  home: {
    hello: '你好',
    header_title1: 'GEA 10th',
    header_title2: '全球合作伙伴大会',
    header_date: '2023年2月19-22日',
    header_city: '四川，九寨沟',
    about_header: 'A place for learning, discovery, innovation, expression and discourse',
    about_section1_title1: '600+ Delegates',
    about_section1_text1: 'from 300 organizations',
    about_section2_title2: '400+ Counselors',
    about_section2_text2: "GEA's top performing channel partners",
    about_section3_title3: '80% Attendees',
    about_section3_text3: 'have more than five years experience in the field',
    discover_more: 'More →',
    sponsor_header: 'Come and join the largest international education recruiters event, sponsorship available',
  },
  about: {
    aboutTitle4_1: 'By attending our conference you will benefit from the following:',
    aboutContent4_1: 'Grand and joyful',
    aboutContent4_2: 'Enjoying a cutting-edge event organizing.',
    aboutContent4_3: 'Renowned speakers',
    aboutContent4_4: 'Listen to the most innovative ideas and get insightful analysis.',
    aboutContent4_5: 'Special featured events',
    aboutContent4_6: 'Share knowledge, Experience and Learn More.',
    aboutContent4_7: 'Networking',
    aboutContent4_8: 'Highly interaction on/off the party.',
    aboutContent4_9: 'Experience and taste of Xiamen',
    aboutContent4_10: 'Admire the extraordinary architecture and the delicious local cuisine.',
    aboutTitle5_1: 'Who Attends?',
    aboutContent5_1: 'The conference attracts professionals and decision makers from education organizations, international schools, education providers and representatives from public/government authorities.',
    aboutContent5_2: '600+ delegates from 300 organizations.',
    aboutContent5_3: "400+ GEA's top performing channel partners counselors.",
    aboutContent5_4: 'Approximately 80% of the attendees have more than five years experience in the field.',
    aboutContent5_5: 'Be part of the conference',
    aboutContent5_6:'98.78% of Delegates are interested in attending the next event.',
  },
  agenda: {
    agendaTitle1_1: 'GEA 10th Annual Conference Agenda',
    date1: 'Sunday, 19th February 2023 ',
    time1_1: '14:00-16:00',
    agenda1_1: 'Arrival and Check-in',
    time1_2: '15:00-18:00',
    agenda1_2: 'Keynote Speech by Official Authorities',
    time1_3: '19:00-21:00',
    agenda1_3: 'Welcome Reception Dinner - Casual',

    date2: 'Monday, 20th February 2023',
    time2_1: '09:00-10:00',
    agenda2_1: 'Keynote Speech',
    time2_2: '10:00-12:30',
    agenda2_2: 'Speed Dating (focus on UK/Canada/Europe)',
    time2_3: '12:30-14:00',
    agenda2_3: 'Buffet Lunch',
    time2_4: '14:00-17:30',
    agenda2_4: 'Part I: Speed Dating (focus on UK/Canada/Europe)',
    time2_5: '15:00-17:00',
    agenda2_5: 'Part II: Roundtable Meeting with Official Authorities, School Reps and VIP Agents',
    time2_6: '18:30-21:30',
    agenda2_6: 'Bonfire Dinner',

    date3: 'Tuesday, 21st February 2023',
    time3_1: '09:00-10:00',
    agenda3_1: 'Keynote Speech',
    time3_2: '10:00-12:00',
    agenda3_2: 'Speed Dating (focus on US/ANZ/Singapore)',
    time3_3: '12:00-12:30',
    agenda3_3: 'Group Photograph',
    time3_4: '12:30-14:00',
    agenda3_4: 'Buffet Lunch',
    time3_5: '14:00-17:30',
    agenda3_5: 'Part I: Speed Dating (focus on US/ANZ/Singapore)',
    time3_6: '15:00-17:00',
    agenda3_6: 'Part II: Roundtable Meeting with Official Authorities, School Reps and International Schools',
    time3_7: '19:30-21:30',
    agenda3_7: 'Charity Night',
    time3_8: '22:00-24:00',
    agenda3_8: 'After Party',

    date4: 'Wednesday, 22nd February 2023',
    time4_1: '09:00-12:00',
    agenda4_1: 'Free time, Wrap-up & Hotel Check out, the trip to Jiuzhai Valley',
  },
  system: {
    systemTitle1_1: 'E-Brochures Zone 院校资料录入专区',
    systemContent1_1: '本次大会，GEA将专门在院校与代理培训过程中引进【线上平台】，此平台将可以预先让本次参会院校在会议开始之前上传贵学校相关资料。与会期间，所有代理将可以通过扫码直接进入该平台。这不仅能实现更高效的信息获取，并且解决了以往培训时顾问重复索取资料，培训后无法形成信息长期驻留的痛点。',
    systemContent1_2: '会后，系统后台监测将可以统计贵校在会议之后的页面阅读以及资料下载量情况。并且通过后台监测可以分析出对贵校项目感兴趣的GEA代理的大致地域分布情况。 这将十分有助于贵校在下一年的中国市场中做出更精准的市场投放和定位。',
    systemTitle2_1: '【院校资料录入专区】',
    systemContent2_1: '上传开放日期：11月',
    systemContent2_2: '请注意：',
    systemContent2_2_1: '登录后请尽量完成填贵校资讯，并且在【文件上传】上传培训时的PPT以及推广学校的电子档Brochures等pdf文件',
    systemContent2_2_2: '每个文件的大小建议小于10 MB',
    systemContent2_2_3: '如您在年会开启前未能及时上传相关文件，可在年会结束后通过上述方式登录后台完成上传',
  }
};
